/* global $ */
/* eslint no-bitwise: 0 */
/* eslint no-unused-vars: 0  */

import { ResponsiveAccordionTabs } from 'foundation-sites';
import { viewportWidth } from '../helpers/dom-tools';

let isSmall = true;

document.addEventListener('DOMContentLoaded', function () {
	$('.accordion__tab').each(function () {
		$(this).find('.accordion-item:first-child').addClass('is-active');
		const $accordionTabs = new ResponsiveAccordionTabs($(this));
	});
	if (viewportWidth() <= 991) {
		// From large to small
		isSmall = true;
	} else if (viewportWidth() >= 992) {
		// From small to large
		isSmall = false;
	}
});

// $(window).resize(function () {
// 	// Fires once only if crossing the breakpoint
// 	if (viewportWidth() <= 991 && !isSmall) {
// 		// From large to small
// 		isSmall = true;
// 	} else if (viewportWidth() >= 992 && isSmall) {
// 		// From small to large
// 		isSmall = false;
// 		// resets tabbed content to first tab open (to prevent multiple tabs open from the mobile accordion view or no tabs open if all collapsed)
// 		$('.accordion__tab').each(function () {
// 			$(this).find('.accordion-item:first-child').addClass('is-active');
// 			const $accordionTabs = new ResponsiveAccordionTabs($(this));
// 		});
// 	}
// });
